import { connect } from 'react-redux';
import NewLandingFooter from './NewLandingFooter';
import { goToPageAndScroll } from '../../redux/router/actions';

const mapDispatchToProps = {
  goToPageAndScroll,
};

export default connect(null, mapDispatchToProps)(NewLandingFooter);
